export const BOOT_SPLASH_VIDEO_ID = 'boot-splash-video';
export const BOOT_SPLASH_ROOT_ID = 'boot-splash';

export function isStandalonePwa() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true
  );
}

export function getBootSplashVideo() {
  return document.getElementById(BOOT_SPLASH_VIDEO_ID);
}

export function getBootSplashRoot() {
  return document.getElementById(BOOT_SPLASH_ROOT_ID);
}

export function hideBootSplash() {
  const root = getBootSplashRoot();
  if (!root) return;

  root.classList.add('boot-splash-exit');
  window.setTimeout(() => {
    root.remove();
  }, 600);
}

export function removeBootSplashImmediately() {
  getBootSplashRoot()?.remove();
}

export function attachBootVideoEnded(onEnded) {
  const video = getBootSplashVideo();
  if (!video) {
    onEnded?.();
    return () => {};
  }

  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    onEnded?.();
  };

  const onEnd = () => finish();
  const onError = () => finish();

  video.addEventListener('ended', onEnd);
  video.addEventListener('error', onError);

  if (video.ended) {
    finish();
  } else if (video.paused) {
    video.play().catch(() => {});
  }

  return () => {
    video.removeEventListener('ended', onEnd);
    video.removeEventListener('error', onError);
  };
}
